import {
  LOAD_OPEN_INCIDENT_SUCCESS,
  LOAD_CLOSE_INCIDENT_SUCCESS
} from "./incidentActionTypes";

export default (state = false, action) => {
  switch (action.type) {
    case LOAD_OPEN_INCIDENT_SUCCESS:
      if (action.logIncident.incidents.length === 0) {
        return true;
      }
      return false;
    case LOAD_CLOSE_INCIDENT_SUCCESS:
      return false;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/incidents/isOpenIncidentEmptyReducer.js